import { Booking } from "../components/booking-page/store/slice";
import { formatDateTime, formatUTCDateTime } from "./date";

export const getBookingTextData = (booking: Booking) => `
Departure country   ${booking.route.departure_country.name}
Arrival country     ${booking.route.arrival_country.name}
Departure time      ${formatUTCDateTime(booking.departure_at)}
Arrival time        ${formatUTCDateTime(booking.arrival_at)}
Duration            ${booking.duration}
Ferry company       ${booking.route.company_name}
Vehicle type        ${booking.vehicle_type?.name || "-"}
Cargo type          ${booking.cargo_type?.name || "-"}
Trailer type        ${booking.trailer_type?.name || "-"}
Vehicle number      ${booking.vehicle_number ?? "-"}
Vehicle reg country ${booking.vehicle_registration_country?.name || "-"}
Trailer number      ${booking.trailer_number ?? "-"}
Trailer reg country ${booking.trailer_registration_country?.name || "-"}
Vehicle length      ${booking.vehicle_length ?? "-"}
Vehicle width       ${booking.vehicle_width ?? "-"}
Vehicle weight      ${booking.vehicle_weight ?? "-"}
Plug-in             ${
  booking.plug_in == null ? "-" : booking.plug_in ? "Yes" : "No"
}
ADR                 ${booking.adr == null ? "-" : booking.adr ? "Yes" : "No"}
Customer reference  ${booking.customer_reference ?? "-"}
Booking reference   ${booking.booking_reference ?? "-"}
Ordered at          ${formatDateTime(booking.ordered_at)}`;
